import { ChangeEvent, FC } from 'react';

import { FileUploader } from '@beeline/design-system-react/extracted-styles';

import clsx from 'clsx';

import classes from './FloorMap.module.scss';

export interface FloorMapWithoutBackgroundProps {
  onUpload: (event: ChangeEvent<HTMLInputElement>) => Promise<void>;
  error?: string;
}

export const FloorMapUploader: FC<FloorMapWithoutBackgroundProps> = ({
  onUpload,
  error,
}) => {
  return (
    <div
      className={clsx(
        classes.container,
        classes.border,
        classes.center,
        classes.fallback,
      )}
      data-testid='floorMapUploaderContainer'
    >
      <FileUploader
        dragOverTitle='Отпустите сюда файлы для загрузки'
        title='Перетащите сюда файл'
        linkName='или загрузите документ'
        subTitle='png, jpg'
        multiple={false}
        onChange={onUpload}
        data-testid='floorMapFileUploader'
        error={!!error}
        helperText={error}
        hideFileList
      />
    </div>
  );
};
